import React, { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  en: {
    nav_home: "Home",
    nav_services: "Services",
    nav_about: "About",
    nav_results: "Results",
    nav_testimonials: "Reviews",
    nav_contact: "Contact",
    nav_book: "Book Appointment",
    hero_headline: "Best Dermatologist in Jhansi",
    hero_subtext: "Advanced dermatology, hair transplant, and skin care in Jhansi — trusted by 500+ patients. Expert pimple treatment, hair fall treatment, and laser treatment by Dr. Kuldeep Verma.",
    hero_rating: "4.9 Google Rating",
    hero_reviews: "500+ Happy Patients",
    booking_name: "Full Name",
    booking_phone: "Phone Number",
    booking_service: "Select Treatment",
    booking_date: "Select Date",
    booking_time: "Select Time",
    booking_submit: "Book Appointment",
    booking_success: "Appointment booked successfully!",
    services_title: "Our Treatments",
    services_subtitle: "Comprehensive skin care, hair transplant, pimple treatment, and hair fall treatment in Jhansi",
    services_cta: "Book Appointment",
    about_title: "Dr. Kuldeep Verma — Best Dermatologist in Jhansi",
    about_tagline: "Every treatment is personalized — because no two skins are the same.",
    about_credentials: "MD, DNB — Certified Dermatologist & Hair Transplant Surgeon",
    about_desc: "Dr. Kuldeep Verma is the best dermatologist in Jhansi, renowned for expert skin care, hair transplant, and pimple treatment. With advanced training from Indira Gandhi Medical College (Shimla) and BJMC Ahmedabad, and an IADVL fellowship in Lasers and Hair Transplant, he brings unparalleled expertise to Jhansi. As a leading skin doctor near Medical College Jhansi, he specializes in hair fall treatment, laser treatment, pigmentation, and all skin diseases.",
    about_research: "25+ national and international research publications",
    about_experience: "Years of experience in advanced dermatology",
    about_personalized: "Personalized treatment plans with affordable care",
    results_title: "Real Results",
    results_subtitle: "Real patients. Real transformations by the best dermatologist in Jhansi.",
    testimonials_title: "What Our Patients Say",
    testimonials_subtitle: "Trusted by hundreds of patients — best dermatologist in Jhansi for skin care and hair transplant",
    contact_title: "Visit Our Clinic",
    contact_address: "Sunder Complex, Opp. Medical College Gate No.1 & 2, Bundelkhand University, Jhansi",
    contact_timings: "Mon - Sat: 11:00 AM - 5:30 PM",
    contact_phone: "Call Us",
    contact_whatsapp: "WhatsApp",
    cta_title: "Ready for Clear, Healthy Skin?",
    cta_subtitle: "Visit the best dermatologist in Jhansi. Book your appointment with Dr. Kuldeep Verma for expert pimple treatment, hair transplant, and skin care in Jhansi.",
    cta_button: "Get Clear Skin Today",
    chat_placeholder: "Ask about skin treatments...",
    chat_title: "Skin Care Assistant",
    appointment_title: "Book Your Appointment",
    appointment_subtitle: "Choose a convenient date and time for your visit",
    select_service: "Choose a treatment",
    select_time: "Choose a time slot",
  },
  hi: {
    nav_home: "होम",
    nav_services: "सेवाएं",
    nav_about: "हमारे बारे में",
    nav_results: "परिणाम",
    nav_testimonials: "समीक्षा",
    nav_contact: "संपर्क",
    nav_book: "अपॉइंटमेंट बुक करें",
    hero_headline: "झाँसी के सर्वश्रेष्ठ त्वचा रोग विशेषज्ञ",
    hero_subtext: "झाँसी में उन्नत त्वचा देखभाल, हेयर ट्रांसप्लांट, मुहांसे का उपचार और बालों का झड़ना उपचार — 500+ खुश मरीज़ों द्वारा विश्वसनीय। डॉ. कुलदीप वर्मा।",
    hero_rating: "4.9 गूगल रेटिंग",
    hero_reviews: "500+ खुश मरीज़",
    booking_name: "पूरा नाम",
    booking_phone: "फ़ोन नंबर",
    booking_service: "उपचार चुनें",
    booking_date: "तारीख चुनें",
    booking_time: "समय चुनें",
    booking_submit: "अपॉइंटमेंट बुक करें",
    booking_success: "अपॉइंटमेंट सफलतापूर्वक बुक हो गई!",
    services_title: "हमारे उपचार",
    services_subtitle: "आपकी ज़रूरतों के अनुसार त्वचा और बालों की व्यापक देखभाल",
    services_cta: "अपॉइंटमेंट बुक करें",
    about_title: "डॉ. कुलदीप वर्मा — झाँसी के सर्वश्रेष्ठ त्वचा रोग विशेषज्ञ",
    about_tagline: "हर उपचार व्यक्तिगत है — क्योंकि कोई भी दो त्वचा एक जैसी नहीं होती।",
    about_credentials: "MD, DNB — प्रमाणित त्वचा रोग विशेषज्ञ और हेयर ट्रांसप्लांट सर्जन",
    about_desc: "डॉ. कुलदीप वर्मा झाँसी के सर्वश्रेष्ठ त्वचा रोग विशेषज्ञ हैं। उन्होंने इंदिरा गांधी मेडिकल कॉलेज (शिमला) और BJMC अहमदाबाद से प्रशिक्षण प्राप्त किया है। IADVL फेलोशिप के साथ, वे झाँसी में हेयर ट्रांसप्लांट, मुहांसे उपचार, बालों का झड़ना उपचार, और त्वचा देखभाल में विशेषज्ञ हैं।",
    about_research: "25+ राष्ट्रीय और अंतर्राष्ट्रीय शोध प्रकाशन",
    about_experience: "उन्नत त्वचा विज्ञान में वर्षों का अनुभव",
    about_personalized: "किफायती देखभाल के साथ व्यक्तिगत उपचार योजनाएं",
    results_title: "वास्तविक परिणाम",
    results_subtitle: "वास्तविक मरीज़। वास्तविक परिवर्तन।",
    testimonials_title: "हमारे मरीज़ क्या कहते हैं",
    testimonials_subtitle: "झाँसी भर में सैकड़ों मरीज़ों द्वारा विश्वसनीय",
    contact_title: "हमारे क्लिनिक पर आएं",
    contact_address: "सुंदर कॉम्प्लेक्स, मेडिकल कॉलेज गेट नं.1 और 2 के सामने, बुंदेलखंड विश्वविद्यालय, झाँसी",
    contact_timings: "सोम - शनि: सुबह 11:00 - शाम 5:30",
    contact_phone: "कॉल करें",
    contact_whatsapp: "व्हाट्सएप",
    cta_title: "साफ, स्वस्थ त्वचा के लिए तैयार?",
    cta_subtitle: "आज ही अपना परामर्श बुक करें और आत्मविश्वासी, चमकती त्वचा की ओर पहला कदम बढ़ाएं।",
    cta_button: "आज ही साफ त्वचा पाएं",
    chat_placeholder: "त्वचा उपचार के बारे में पूछें...",
    chat_title: "त्वचा देखभाल सहायक",
    appointment_title: "अपॉइंटमेंट बुक करें",
    appointment_subtitle: "अपनी यात्रा के लिए सुविधाजनक तारीख और समय चुनें",
    select_service: "उपचार चुनें",
    select_time: "समय स्लॉट चुनें",
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('en');
  
  const t = useCallback((key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  }, [language]);
  
  const toggleLanguage = useCallback(() => {
    setLanguage(prev => prev === 'en' ? 'hi' : 'en');
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
}
